import { UseFormReturnType } from '@mantine/form'
import { useDisclosure } from '@mantine/hooks'
import { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { useWorkspace } from '@/components/workspaces/WorkspaceContext'
import { NotificationSettings } from '@/types/notificationSettings'
import { FormValues } from '../DeploymentSettings'
import { SettingsCard } from '../SettingsCard'
import { NotificationSettingsDrawer } from './NotificationSettingsDrawer'
import { NotificationSettingsForm } from './NotificationSettingsForm/NotificationSettingsForm'
import { NotificationSettingsInfo } from './NotificationSettingsInfo/NotificationSettingsInfo'

type NotificationSettingsHandlerProps = {
  form: UseFormReturnType<FormValues>
}

export const NotificationSettingsHandler = ({
  form
}: NotificationSettingsHandlerProps) => {
  const [isDrawerOpen, { open: openDrawer, close: closeDrawer }] =
    useDisclosure()

  const [cachedNotificationSettings, setCachedNotificationSettings] =
    useState<NotificationSettings>(form.getValues().notificationSettings)

  const { membership, workspace } = useWorkspace()

  const notificationMyUser =
    cachedNotificationSettings.workspace_users.includes(membership.id) ||
    cachedNotificationSettings.is_default
      ? membership.user.full_name
      : ''

  const notificationOtherUsers =
    cachedNotificationSettings.workspace_users.filter(
      (userId) => userId !== membership.id
    )

  const handleSaveNotificationSettings = (values: NotificationSettings) => {
    setCachedNotificationSettings(values)
    form.setFieldValue('notificationSettings', values)
    closeDrawer()
  }

  return (
    <>
      <SettingsCard
        title={<FormattedMessage id="deployments.notificationSettings.title" />}
      >
        <NotificationSettingsInfo
          mainUserName={notificationMyUser}
          otherUserCount={notificationOtherUsers.length}
          hasCustomSchedule={
            cachedNotificationSettings.is_default === false &&
            cachedNotificationSettings.schedules.length > 0
          }
          onEdit={openDrawer}
        />
      </SettingsCard>

      <NotificationSettingsDrawer opened={isDrawerOpen} onClose={closeDrawer}>
        <NotificationSettingsForm
          workspaceId={workspace.id}
          defaultEmail={membership.user.email}
          initialValues={cachedNotificationSettings}
          onCancel={closeDrawer}
          onSave={handleSaveNotificationSettings}
        />
      </NotificationSettingsDrawer>
    </>
  )
}
